module.exports = __webpack_public_path__ + "bg_home_lg.0aa1cd8ebfb71da36fb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/perfil/bg_home_lg.jpg
// module id = 279
// module chunks = 2